/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomDefinitionsSortCriteria {
    getFixupPrototypeFunction() { return AppSecopsSbomDefinitionsSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomDefinitionsSortCriteria>): AppSecopsSbomDefinitionsSortCriteria {
        let obj = Object.assign(new AppSecopsSbomDefinitionsSortCriteria(), model);
        AppSecopsSbomDefinitionsSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomDefinitionsSortCriteria>): AppSecopsSbomDefinitionsSortCriteria {
        if (!model) return null;
        return AppSecopsSbomDefinitionsSortCriteria.newInstance(<AppSecopsSbomDefinitionsSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomDefinitionsSortCriteria) {
        if (!obj) return;

        models.AppSecopsSbomDefinitionsSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomDefinitionsSortCriteria): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomDefinitionsSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.AppSecopsSbomDefinitionsSortColumn;

    ascending: boolean;

}
